export enum TipoCausale {
  tutto = 0,
  Pausa = 1,
  Nc = 2
}

export const TIPO_CAUSALE = [
  { value: TipoCausale.tutto, label: 'Tutto' },
  { value: TipoCausale.Pausa, label: 'Pausa Avp' },
  { value: TipoCausale.Nc, label: 'Non conformità' }
];
